import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import icons from '../../utils/icons.json';
import Product from "./singleproduct"
import useDOMWidth from '../../hooks/useDOMWidth';
import { isMobile } from '../../utils/fn';

const parentVariants = {
	initial: {},
	animate: {},
};

const leftBtnVariant = {
	initial: {
		left: -50,
		scale: 0,
	},
	animate: {
		left: 0,
		scale: 1,
		transition: {
			duration: 0.3,
		},
	},
};

const rightBtnVariant = {
	initial: {
		right: -50,
		scale: 0,
	},
	animate: {
		right: 0,
		scale: 1,
		transition: {
			duration: 0.3,
		},
	},
};

function ProductSlider({ data: list, showquantity }) {
	const domWidth = useDOMWidth(window.innerWidth);
	const [position, setPosition] = useState(0);

	const [frameWidth, setFrameWidth] = useState(0);
	const [sliderWidth, setSliderWidth] = useState(0);

	const sliderFrame = useRef(null);
	const slider = useRef(null);

	useEffect(() => {
		if (sliderFrame.current) {
			setFrameWidth(sliderFrame.current.offsetWidth);
		}
		if (slider.current) setSliderWidth(slider.current.scrollWidth);
	}, [sliderFrame, slider, domWidth]);

	useEffect(() => {
		setPosition(0);
	}, [frameWidth, sliderWidth]);

	function moveLeft(e) {
		setPosition(prev => {
			let pos = prev - frameWidth;
			return pos > 0 ? pos : 0;
		});
	}

	function moveRight(e) {
		setPosition(prev => {
			let pos = prev + frameWidth;
			return pos + frameWidth <= sliderWidth ? pos : sliderWidth - frameWidth;
		});
	}

	return (
		<motion.div variants={parentVariants} initial='initial' animate='animate' className='products-slider' ref={sliderFrame}>
			<div className='sliding' ref={slider} style={{ marginLeft: `-${position}px`, overflow: !isMobile() && "hidden" }}>
				{list.map((data, index) => (
					<div className='product-wrapper' key={data.item_code + index}>
						<Product data={data} showquantity={showquantity} />
					</div>
				))}
			</div>
			{!isMobile() &&
				<AnimatePresence>
					{position > 0 && (
						<motion.button
							variants={leftBtnVariant}
							exit={{
								left: -50,
								scale: 0,
								transition: {
									duration: 0.3,
								},
							}}
							onClick={moveLeft}
							className='n-btn left'
							dangerouslySetInnerHTML={{ __html: icons.angle_left }}
							type='button'></motion.button>
					)}
				</AnimatePresence>}
			{!isMobile() &&
				<AnimatePresence>
					{position != sliderWidth - frameWidth && (
						<motion.button
							variants={rightBtnVariant}
							exit={{
								right: -50,
								scale: 0,
								transition: {
									duration: 0.3,
								},
							}}
							onClick={moveRight}
							className='n-btn right'
							dangerouslySetInnerHTML={{ __html: icons.angle_right }}
							type='button'></motion.button>
					)}
				</AnimatePresence>}
		</motion.div>
	);
}

export default React.memo(ProductSlider);
